"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _BookingLocation = _interopRequireDefault(require("./BookingLocation"));

var _BookingDetailsContent = _interopRequireDefault(require("./BookingDetailsContent"));

var _serviceLocationTypes = _interopRequireDefault(require("../../constants/serviceLocationTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BookingLocationDetails = function BookingLocationDetails(_ref) {
  var booking = _ref.booking,
      i18n = _ref.i18n,
      onLocationUrlMount = _ref.onLocationUrlMount,
      onLocationUrlClick = _ref.onLocationUrlClick;
  if (!(booking.location || booking.service.custom_location_text)) return null;
  return /*#__PURE__*/_react["default"].createElement(_BookingDetailsContent["default"], {
    icon: "location",
    title: i18n.location,
    subtitle: booking.service.location_type === _serviceLocationTypes["default"].ONLINE ? i18n.onlineVirtual : null,
    dataAids: {
      content: _dataAids["default"].BOOKING_LOCATION
    }
  }, /*#__PURE__*/_react["default"].createElement(_BookingLocation["default"], {
    booking: booking,
    i18n: i18n,
    onLocationUrlMount: onLocationUrlMount,
    onLocationUrlClick: onLocationUrlClick
  }));
};

BookingLocationDetails.propTypes = {
  booking: _propTypes["default"].shape({
    location: _propTypes["default"].object.isRequired,
    service: _propTypes["default"].shape({
      custom_location_text: _propTypes["default"].string,
      location_type: _propTypes["default"].string.isRequired
    })
  }).isRequired,
  i18n: _propTypes["default"].shape({
    location: _propTypes["default"].string.isRequired,
    onlineVirtual: _propTypes["default"].string.isRequired,
    nullTeleconferenceUrl: _propTypes["default"].string.isRequired
  }).isRequired,
  onLocationUrlMount: _propTypes["default"].func,
  onLocationUrlClick: _propTypes["default"].func
};
var _default = BookingLocationDetails;
exports["default"] = _default;